export const DATE_FORMATS = {
    // ISO 8601 format for API communication and storage
    ISO_8601: 'yyyy-MM-dd',

    // Display formats for UI
    DISPLAY_SHORT: 'MMM d, yyyy',
    DISPLAY_WITH_TIME: 'MMM d, yyyy h:mm a',
    DISPLAY_LONG: 'MMMM d, yyyy',

    // Order-specific formats
    ORDER_DATE_WITH_TIME: 'MMM d, h:mm a',
    ORDER_DATE_MOBILE: 'MMM d',

    // Time formats
    TIME_12H: 'h:mm a',
    TIME_24H: 'HH:mm',

    // API time format (12-hour with AM/PM)
    API_TIME: 'hh:mm a',
} as const;

export type DateFormat = (typeof DATE_FORMATS)[keyof typeof DATE_FORMATS];

/**
 * Date range type constants for consistent usage across analytics and filters
 * Provides predefined date ranges for common use cases
 */
export const DATE_RANGE_TYPES = {
    // Standard date ranges (used in analytics and filters)
    LAST_7_DAYS: 'last7Days',
    LAST_14_DAYS: 'last14Days',
    LAST_30_DAYS: 'last30Days',
    LAST_90_DAYS: 'last90Days',

    // Additional filter-specific ranges
    LAST_24_HOURS: 'last24Hours',

    // Future date ranges (for appointments)
    NEXT_7_DAYS: 'next7Days',
    NEXT_14_DAYS: 'next14Days',
    NEXT_30_DAYS: 'next30Days',
    NEXT_90_DAYS: 'next90Days',
    NEXT_3_MONTHS: 'next3Months',

    // Special ranges
    MONTH_TO_DATE: 'monthToDate',
    CUSTOM: 'custom',
} as const;

/**
 * Date range type derived from constants for type safety
 */
export type DateRangeType = (typeof DATE_RANGE_TYPES)[keyof typeof DATE_RANGE_TYPES];
